import WallexService from './WallexService'
import { SimplePaymentRetrieve, SimplePaymentUpdatePayload } from '../domain/SimplePayment'

export default class SimplePaymentService extends WallexService {
    public static retrieve(simplePaymentId: string): Promise<SimplePaymentRetrieve> {
        return this.instance()
            .get('simple_payments/' + simplePaymentId)
            .then((response) => {
                const body = response.data as {
                    result: SimplePaymentRetrieve
                }

                return body.result
            })
    }

    public static update(simplePaymentId: string, payload: SimplePaymentUpdatePayload) {
        return this.instance()
            .patch('simple_payments/' + simplePaymentId, payload)
            .then((response) => {
                const body = response.data as {
                    result: SimplePaymentRetrieve
                }

                return body.result
            })
    }
}
